
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M17.71 14.23l-.962-.96a2.571 2.571 0 010-3.638l7.88-7.879a2.571 2.571 0 013.636 0l7.983 7.983a2.571 2.571 0 010 3.637l-7.88 7.879a2.571 2.571 0 01-3.636 0l-.961-.961M14.23 17.71l-.96-.962a2.571 2.571 0 00-3.638 0l-7.879 7.88a2.571 2.571 0 000 3.636l7.983 7.983a2.571 2.571 0 003.637 0l7.879-7.88a2.571 2.571 0 000-3.636l-.961-.961M13 25l12-12"}})])])
          )
        }
      }
    